<template>
  <router-view/>
</template>

<script>
import { kickAgent, startAgentSubscriptionPolling, startAgentPermissionsPolling } from '@/utils/agentSession'
import { kickUser, expireUser } from '@/utils/userSession'

export default {
  name: 'App',
  data () {
    return {
      stopAgentSubscriptionPoll: null,
      stopAgentPermissionsPoll: null
    }
  },
  mounted () {
    window.addEventListener('agent-session-kicked', this.onAgentKicked)
    window.addEventListener('agent-subscription-expired', this.onAgentSubscriptionExpired)
    window.addEventListener('agent-session-started', this.onAgentSessionStarted)
    window.addEventListener('user-session-kicked', this.onUserKicked)
    window.addEventListener('user-session-expired', this.onUserSessionExpired)

    // Start polling if an agent is currently logged in
    if (localStorage.getItem('agent_token')) {
      this.stopAgentSubscriptionPoll = startAgentSubscriptionPolling()
      this.stopAgentPermissionsPoll = startAgentPermissionsPolling()
    }
  },
  beforeUnmount () {
    window.removeEventListener('agent-session-kicked', this.onAgentKicked)
    window.removeEventListener('agent-subscription-expired', this.onAgentSubscriptionExpired)
    window.removeEventListener('user-session-kicked', this.onUserKicked)
    window.removeEventListener('user-session-expired', this.onUserSessionExpired)

    window.removeEventListener('agent-session-started', this.onAgentSessionStarted)
    if (this.stopAgentSubscriptionPoll) this.stopAgentSubscriptionPoll()
    if (this.stopAgentPermissionsPoll) this.stopAgentPermissionsPoll()
  },
  methods: {
    onAgentSessionStarted () {
      // Agent just logged in during this SPA session — start pollers if not already running
      if (!this.stopAgentSubscriptionPoll) {
        this.stopAgentSubscriptionPoll = startAgentSubscriptionPolling()
      }
      if (!this.stopAgentPermissionsPoll) {
        this.stopAgentPermissionsPoll = startAgentPermissionsPolling()
      }
    },
    onAgentKicked () {
      if (this.$route.name === 'agent-kicked') return
      kickAgent(this.$router)
    },
    onAgentSubscriptionExpired () {
      if (this.$route.name === 'agent-kicked') return
      if (this.stopAgentSubscriptionPoll) {
        this.stopAgentSubscriptionPoll()
        this.stopAgentSubscriptionPoll = null
      }
      this.$router.replace('/agent/kicked?reason=subscription_expired').then(() => {
        localStorage.removeItem('agent_token')
        localStorage.removeItem('agent_data')
        localStorage.removeItem('auth_token')
      }).catch(() => {})
    },
    onUserKicked () {
      if (this.$route.name === 'user-kicked') return
      kickUser(this.$router)
    },
    onUserSessionExpired () {
      if (this.$route.name === 'login') return
      expireUser(this.$router)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  --sidebar-width: 280px;
}

/* When sidebar is collapsed — body class has higher specificity than any scoped component CSS */
body.sidebar-collapsed .main-content {
  margin-left: 64px;
}

@media (max-width: 768px) {
  .main-content,
  body.sidebar-collapsed .main-content {
    margin-left: 0;
  }
}
</style>
